import { useMemo } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { DayPlannerScreen, type DayPlannerAction } from '@mrrmlab/feature-day-planner';

export function HeuteRoute() {
  const navigate = useNavigate();
  const actions = useMemo<DayPlannerAction[]>(
    () => [
      {
        label: 'Manuelle Aufgabe erstellen',
        hint: 'Direkt in der Todo-Liste',
        onPress: () => void navigate({ to: '/todo' }),
      },
      {
        label: 'Mail-Konto verbinden',
        hint: 'Eingehende Mails werden zu Candidates',
        onPress: () => void navigate({ to: '/einstellungen/mail' }),
      },
      {
        label: 'Kalender verbinden',
        hint: 'ICS-Feed für Termine im Tagesplan',
        onPress: () => void navigate({ to: '/einstellungen/kalender' }),
      },
    ],
    [navigate],
  );
  return <DayPlannerScreen emptyStateActions={actions} />;
}
